<h2 mat-dialog-title>Add new SAP Symbol</h2>
<form [formGroup]="newSymbolForm">
  <mat-dialog-content class="parameter-fields-container">
    @if(errorMessage){
    <div class="error-message">{{ errorMessage }}</div>
    }
    <mat-form-field>
      <mat-label>SAP Symbol</mat-label>
      <input matInput formControlName="symbol" name="symbol"
        (input)="transformToUppercase('symbol')" />
      @if(newSymbolForm.controls.symbol.hasError('maxlength')){
      <mat-error>{{ "Maximum number of characters is 50" }}</mat-error>
      } @if(newSymbolForm.controls.symbol.hasError('pattern') &&
      newSymbolForm.controls.symbol.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Index Name</mat-label>
      <input matInput formControlName="indexName" name="indexName"
        (input)="transformToUppercase('indexName')" />
      @if(newSymbolForm.controls.indexName.hasError('maxlength')){
      <mat-error>{{ "Maximum number of characters is 50" }}</mat-error>
      } @if(newSymbolForm.controls.indexName.hasError('pattern') &&
      newSymbolForm.controls.indexName.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Index Type</mat-label>
      <mat-select formControlName="indexType">
        @for(type of indexTypes; track type){
        <mat-option [value]="type">{{ type || '' }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cancel</button>
    <button
      mat-button
      cdkFocusInitial
      [disabled]="!newSymbolForm.valid"
      (click)="addNewSymbol()"
    >
      Add
    </button>
  </mat-dialog-actions>
</form>
